module.exports = __webpack_public_path__ + "static/assets/3dbac2691eb8fe67ed2f34cd0a7626c6.svg";